import React from 'react';
import VastFormRedux from '../../../containers/sections/vastInspector/VastForm';
import { VI_DESCRIPTION, VI_DESCRIPTION_PART2, VF_INIT_AREA } from '../../../constants/Labels';

class VastInspector extends React.Component {
  render() {
    return (
      <div className="vastInspector">
        <div className="description">{VI_DESCRIPTION}</div>
        <VastFormRedux initArea={VF_INIT_AREA} />
        <div className="description more">
          <i>{VI_DESCRIPTION_PART2}</i>
        </div>
      </div>
    );
  }
}

export default VastInspector;
